export const getStringType = data => {
  var array = [];
  if (typeof data == 'string') {
    return data;
  } else if (data && data.length > 0) {
    for (let item of data) array.push(item.Value);
  }
  return array.toString();
};
